// Tiny analytics helper — wraps Umami's window.umami.track API.
// Privacy-first: only event names + non-identifying metadata.
// Safe to call before the Umami script has loaded (no-ops gracefully).

export function track(event, data) {
  try {
    if (typeof window === "undefined") return;
    if (!window.umami || typeof window.umami.track !== "function") return;
    if (data && typeof data === "object") {
      window.umami.track(event, data);
    } else {
      window.umami.track(event);
    }
  } catch {
    /* analytics must never break the app */
  }
}
